import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from 'react-i18next';
import"./style.css";

const Footer = () => {
  const {t} = useTranslation();

  return (
    <React.Fragment>
      <footer className="footer">
        <Container className="footer-container">
          <Row>
            <Col sm={6}> © {t("QUESS")}</Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
              {t("SP")} {new Date().getFullYear()}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
